const Views = {
  OME_MEET_CONTACTS: 'Entry Contacts',
  OME_MEET_CONTACTS_DETAIL: 'Entry Contact',
  OME_MEET_ROSTER_ENTRIES_DETAIL: 'Manage Athlete Events',
  OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_SELECTION: 'Individual Event Selection',
  OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE: 'Individual Event Entry Override Time',
  OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION: 'Individual Bonus Event Selection',
  OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE: 'Individual Bonus Event Entry Override Time',
  OME_MEET_CREDENTIALS: 'Credentials',
  OME_MEET_CREDENTIALS_SELECTION: 'Credentials Selection',
  OME_MEET_SUBMIT: 'Submit',
  OME_MEET_SUBMITTED: 'Submitted'
};

const VIEW_DATA = [
  {
    name: Views.OME_MEET_CONTACTS,
    subHeaderText: 'Entry Contacts',
    instructionText: 'Provide at least one Entry Contact.',
    nextButtonText: 'Continue',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_CONTACTS_DETAIL,
    subHeaderText: 'Entry Contact',
    instructionText: 'Provide an Entry Contact.',
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_DETAIL,
    subHeaderText: 'Manage Athlete Events',
    instructionText: "Add or Remove Event Entries.",
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_SELECTION,
    subHeaderText: 'Individual Event Selection',
    instructionText: "Add or Remove Individual Event Entries.",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE,
    subHeaderText: 'Individual Event Entry Override Time',
    instructionText: "",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION,
    subHeaderText: 'Individual Bonus Event Selection',
    instructionText: "Add or Remove Individual Bonus Event Entries.",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE,
    subHeaderText: 'Individual Bonus Event Entry Override Time',
    instructionText: "",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_CREDENTIALS,
    subHeaderText: 'Credentials',
    instructionText: "Add or Remove Credentials. The Number of Allowed Credentials is Determined by the Meet's Deck Pass Rules.",
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_CREDENTIALS_SELECTION,
    subHeaderText: 'Credentials Selection',
    instructionText: `Filter by a Credential. Then Select or Unselect Members to Assign to that Credential. Please Save Any Changes Before Filtering by a Different Credential or Clicking 'Clear Filter' - Unsaved Changes Will Not be Retained.`,
    nextButtonText: 'Save',
    backButtonText: 'Back',
  },
  {
    name: Views.OME_MEET_SUBMIT,
    subHeaderText: 'Submit',
    instructionText: 'Make Purchases and Submit the Athlete Entry.'
  },
  {
    name: Views.OME_MEET_SUBMITTED,
    subHeaderText: 'OME Athlete Entry is Submitted & Created',
    instructionText: 'Optional: Make Additional Purchases and Resubmit the Athlete Entry.'
  }
];

export const getViewData = (viewName) => {
  const view = VIEW_DATA.find(x => x.name === viewName);
  return { ...view };
};

export default Views;